import React, { useState } from 'react';
import { Button, Typography, Form, Input } from 'antd';
import { CardStyle } from './AuthLayout';
import { NewPasswordApi } from '../../services/api_collection';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;
const { Password } = Input;

const NewPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const token = location?.search?.split('=')?.[1];

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        newPassword: values?.newPassword,
        token: token
      };
      const res = await NewPasswordApi(payload);
      if (res.statusCode === 200) {
        toast.success(res?.message);
        navigate('/');
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <CardStyle>
      <div>
        <Title
          level={1}
          style={{
            fontSize: '48px',
            lineHeight: '50px',
            fontWeight: 700,
            margin: 0
          }}>
          Create a New Password
        </Title>
        <Text style={{ fontSize: '16px', color: '#767676' }}>
          Enter a password unique to this account.
        </Text>
      </div>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          label={<Text style={{ fontSize: '16px', fontWeight: 400 }}>New Password</Text>}
          name="newPassword"
          required={false}
          rules={[
            { required: true, message: 'New Password is required' },
            { min: 8, message: 'Password must be at least 8 characters' },
            {
              pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*])/,
              message: 'Password contain number, special character and alphabets'
            }
          ]}
          validateFirst>
          <Password
            placeholder="Enter New Password"
            size="large"
            style={{
              height: '47px',
              borderRadius: '8px',
              fontSize: '16px'
            }}
            onKeyDown={(e) => {
              if (e.key === ' ') {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\s/g, '');
              e.target.value = cleaned;
            }}
          />
        </Form.Item>
        <Form.Item
          label={<Text style={{ fontSize: '16px', fontWeight: 400 }}>Confirm New Password</Text>}
          name="confirmPassword"
          required={false}
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Password is required' },
            { min: 8, message: 'Password must be at least 8 characters' },
            {
              pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*])/,
              message: 'Password contain number, special character and alphabets'
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Password do not match'));
              }
            })
          ]}
          validateFirst>
          <Password
            placeholder="Enter Confirm Password"
            size="large"
            style={{
              height: '47px',
              borderRadius: '8px',
              fontSize: '16px'
            }}
            onKeyDown={(e) => {
              if (e.key === ' ') {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\s/g, '');
              e.target.value = cleaned;
            }}
          />
        </Form.Item>
        <Form.Item style={{ margin: 0 }}>
          <Button htmlType="submit" type="primary" className="buttonStyle" loading={loading}>
            Create Password
          </Button>
        </Form.Item>
      </Form>
    </CardStyle>
  );
};

export default NewPassword;
